/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../app/shared/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) {}
  showErrorDialog(msg: string) {
    const dialogRef = this.dialog.open(DialogComponent, {
      autoFocus: true,
      data: {
        header: 'Error',
        messageTitle: '',
        message: msg,
        confirmButtonText: 'OK'
      }
    });

    dialogRef.afterClosed().subscribe((val) => {
      if (val === 'OK') {
      }
    });
  }
}
